import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Template from "../images/Orevan-Header.gif";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordUser } from "../redux/features/auth/authSlice";

function ForgotPassword() {
  const dispatch = useDispatch();
  const { forgotPasswordLoading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email is required");
      return;
    }

    try {
      setError("");
      await dispatch(forgotPasswordUser({ email })).unwrap();
      toast.success("Password reset link sent to your email!");
      navigate("/login");
      setEmail("");
    } catch (err) {
      toast.error(err.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="bg-white rounded-2xl border-4 border-white shadow-sm flex flex-col md:flex-row w-full max-w-5xl min-h-[32rem] overflow-hidden">
        {/* Left side with image */}
        <div className="md:w-1/2 w-full min-h-[200px] md:min-h-full">
          <img
            className="h-full w-full object-cover"
            src={Template}
            alt="Orevan Portal"
          />
        </div>

        {/* Right side with content */}
        <div className="md:w-1/2 w-full flex flex-col justify-center text-center p-6 md:p-8">
          <h1 className="font-bold text-2xl mb-2">Forgot Password</h1>
          <p className="text-gray-600 text-sm mb-6 capitalize">
            Enter your email address and we'll send you a link to reset your
            password.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="flex flex-col space-y-5">
              {/* Email */}
              <div className="flex flex-col items-start gap-1">
                <label className="text-lg font-semibold text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="border border-slate-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightPurple"
                  placeholder="Enter Your Email"
                />
                {error && (
                  <p className="text-red-500 text-sm font-medium pt-1 pl-1">
                    {error}
                  </p>
                )}
              </div>

              {/* Submit button */}
              <button
                type="submit"
                disabled={forgotPasswordLoading}
                className={`bg-lightPurple text-white p-2.5 rounded-lg font-semibold transition duration-300 ${
                  forgotPasswordLoading
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-purpleColor"
                }`}
              >
                {forgotPasswordLoading && (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    className="animate-spin mr-1"
                  />
                )}
                {forgotPasswordLoading ? "Sending..." : "Send Reset Link"}
              </button>

              {/* Back to Login */}
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="inline-flex items-center justify-center gap-2 text-sm text-gray-600 font-medium hover:text-purpleColor transition duration-200 pt-2"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
